import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { authService } from "../services";
import { useAuthStore } from "../store";
import { FiMail, FiLock, FiArrowLeft } from "react-icons/fi";

const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error(t("errors.fillAllFields"));
      return;
    }

    setLoading(true);
    try {
      const response = await authService.login(formData);
      console.log('Login response:', response);
      const { token, user } = response.data;
      console.log('Token:', token, 'User:', user);

      if (!token || !user) {
        throw new Error('Token o usuario no recibidos del servidor');
      }

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      useAuthStore.setState({ user, token });

      toast.success(t("auth.loginSuccess"));
      
      // Navigate con pequeño delay para asegurar que el estado se actualiza
      setTimeout(() => {
        navigate("/dashboard");
      }, 100);
    } catch (error) {
      console.error('Login error details:', error);
      const errorMessage = error.response?.data?.message || error.message || t("errors.serverError");
      toast.error(errorMessage);
      setLoading(false);
    }
  
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <button
          onClick={() => navigate("/")}
          className="auth-back-button"
          type="button"
        >
          <FiArrowLeft />
          {t("common.back") || "Volver"}
        </button>

        <h2 className="auth-title">{t("auth.loginTitle")}</h2>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">{t("common.email")}</label>
            <div className="input-group">
              <FiMail className="input-group-icon" />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t("common.email")}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">{t("common.password")}</label>
            <div className="input-group">
              <FiLock className="input-group-icon" />
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={t("common.password")}
              />
            </div>
          </div>

          <button type="submit" disabled={loading} className="auth-button">
            {loading ? t("common.loading") : t("common.login")}
          </button>
        </form>

        <p className="auth-link">
          {t("auth.noAccount")}
          <a href="/register">{t("common.register")}</a>
        </p>
      </div>
    </div>
  );
};

export default Login;
